import { render, staticRenderFns } from "./vote-tip.vue?vue&type=template&id=3d4ef670&scoped=true"
import script from "./vote-tip.vue?vue&type=script&lang=js"
export * from "./vote-tip.vue?vue&type=script&lang=js"
import style0 from "./vote-tip.vue?vue&type=style&index=0&id=3d4ef670&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4ef670",
  null
  
)

export default component.exports